import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FlaggedCommentsService {
  constructor(private firestore: AngularFirestore) {}

  getFlaggedComments(): Observable<any[]> {
    return this.firestore
      .collection('flaggedContent', ref =>
        ref.where('type', '==', 'comment').where('status', '==', 'pending')
      )
      .valueChanges({ idField: 'id' });
  }

  approveComment(comment: any): Promise<void> {
    return this.firestore.collection('flaggedContent').doc(comment.id).update({
      status: 'approved',
    });
  }

  rejectComment(comment: any): Promise<void> {
    const batch = this.firestore.firestore.batch();

    // Update the flag status
    const flagRef = this.firestore
      .collection('flaggedContent')
      .doc(comment.id).ref;
    batch.update(flagRef, { status: 'rejected' });

    // Mark the actual comment as deleted if commentId exists
    if (comment.commentId) {
      const commentRef = this.firestore
        .collection('comments')
        .doc(comment.commentId).ref;
      batch.update(commentRef, {
        isDeleted: true,
        text: 'This comment has been removed by a moderator',
      });
    }

    return batch.commit();
  }
}
